import { useRef } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Transition, TransitionGroup } from "react-transition-group";

const NAV_GROUPS = [
  ['Home', 'About', 'Works'],
  ['OC', 'Gallery'],
];

const transitionStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    transition: 'opacity 200ms ease-in-out',
    opacity: 1
  },
  exiting: {
    transition: 'opacity 200ms ease-in-out',
    opacity: 0
  }
};

// TransitionGroup passes its props (in, onExited, ...) through to the Transition.
function FadeMain(props) {
  const ref = useRef(null);

  return (
    <Transition {...props} nodeRef={ref} timeout={0}>
      {(state) => (
        <main ref={ref} style={transitionStyles[state]}>
          <Outlet />
        </main>
      )}
    </Transition>
  );
}

function App() {
  const location = useLocation();

  return (
    <div className="App">

      <div id="app_without_footer">
        <header id='catadioptric'>
          <div>CATADIOPTRIC</div>
          <div id='second'>CATADIOPTRIC</div>
        </header>

        <nav className="Navigator">
          {NAV_GROUPS.map((group, i) => (
            <ul className='Nav_div' key={i}>
              {group.map(page => (
                <li key={page}>
                  <NavLink
                    to={`/${page}`}
                    className={({ isActive }) => isActive ? 'active-navlink' : 'idle-navlink'}
                  >{page.toUpperCase()}</NavLink>
                </li>
              ))}
            </ul>
          ))}
        </nav>
        <TransitionGroup className="transitionGroup">
          <FadeMain key={location.pathname} />
        </TransitionGroup>
      </div>
      <footer>
        <div>
          <a href="mailto:TSOTDS101@gmail.com" target="_blank" rel="noreferrer">
            TSOTDS101@gmail.com
          </a>
        </div>
        <div id='copyright'>
          © 2025-2026 CATADIOPTRIC<br/>
          All rights reserved.
        </div>
      </footer>
    </div>
  );
}

export default App;
